import { TrendingUp } from "lucide-react";

type Props = {
  cardName: string;
  conditionMin?: string | null;
  target: number;
};

/**
 * Guide-price indicator. Market-value auto-suggestion is intentionally
 * disabled — external price sources (TCGplayer / PriceCharting) can't be
 * reliably matched to the exact card/set/grade, so showing a percentage
 * comparison risks misleading users. We only surface the neutral empty
 * state until on-platform sales data is sufficient.
 */
export function GuidePriceIndicator({ cardName }: Props) {
  if (!cardName.trim()) return null;

  return (
    <div className="rounded-md border border-border bg-background/40 p-3 text-xs text-muted-foreground">
      <TrendingUp className="mr-1.5 inline h-3.5 w-3.5" />
      No recent sales data available for this card yet — pricing guidance will appear here once more transactions occur on the platform.
    </div>
  );
}
